import { FormEvent, useEffect, useState } from 'react';
import axios from 'axios';

const SsoCompleteProfilePage = () => {
    const [token, setToken] = useState<string | null>(null);
    const [stageName, setStageName] = useState('');
    const [dob, setDob] = useState('');
    const [licenseID, setLicenseID] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        try {
            const t = sessionStorage.getItem('ssoToken');
            const n = sessionStorage.getItem('ssoStageName') || '';
            setToken(t);
            setStageName(n);
        } catch (_) {}
    }, []);

    const submit = async (e: FormEvent) => {
        e.preventDefault();
        if (!token) {
            setError('Your sign-in session has expired. Please sign in again.');
            return;
        }
        if (!dob || !licenseID) {
            setError('Please fill in both fields.');
            return;
        }
        setSubmitting(true);
        setError(null);
        try {
            await axios.post('/api/sso/complete-profile', {
                token,
                dateOfBirth: dob,
                licenseID,
            });
            try {
                sessionStorage.removeItem('ssoToken');
                sessionStorage.removeItem('ssoStageName');
            } catch (_) {}
            setDone(true);
        } catch (err: any) {
            setError(
                err?.response?.data?.message ||
                    'Unable to save your profile. Please try again.'
            );
        } finally {
            setSubmitting(false);
        }
    };

    if (!token && !done) {
        return (
            <div style={{ padding: 32, textAlign: 'center' }}>
                <h2>Session expired</h2>
                <p>
                    Please <a href="/sso/start">sign in again</a> to finish
                    setting up your profile.
                </p>
            </div>
        );
    }

    if (done) {
        return (
            <div style={{ padding: 32, textAlign: 'center' }}>
                <h2>You're all set!</h2>
                <p>
                    Welcome, <strong>{stageName || 'guest'}</strong>. Porky's
                    staff has you on tonight's roster.
                </p>
            </div>
        );
    }

    return (
        <div style={{ padding: 32, maxWidth: 480, margin: '0 auto' }}>
            <h2>One last step</h2>
            <p>
                We need a couple more details before your check-in is complete.
            </p>

            {error && (
                <p style={{ color: '#c00', marginBottom: 16 }}>{error}</p>
            )}

            <form onSubmit={submit}>
                <label style={{ display: 'block', marginBottom: 12 }}>
                    Date of birth
                    <input
                        type="date"
                        value={dob}
                        onChange={(e) => setDob(e.target.value)}
                        required
                        style={{
                            display: 'block',
                            width: '100%',
                            padding: 8,
                            marginTop: 4,
                        }}
                    />
                </label>

                <label style={{ display: 'block', marginBottom: 12 }}>
                    Driver license number
                    <input
                        type="text"
                        value={licenseID}
                        onChange={(e) => setLicenseID(e.target.value)}
                        maxLength={64}
                        required
                        style={{
                            display: 'block',
                            width: '100%',
                            padding: 8,
                            marginTop: 4,
                        }}
                    />
                </label>

                <button
                    type="submit"
                    disabled={submitting}
                    style={{
                        padding: '10px 20px',
                        fontSize: 16,
                        cursor: submitting ? 'not-allowed' : 'pointer',
                    }}
                >
                    {submitting ? 'Saving…' : 'Finish check-in'}
                </button>
            </form>
        </div>
    );
};

export default SsoCompleteProfilePage;
